import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {

  public imgSet = ["https://willrich.com/wp-content/uploads/2018/08/How-Will-Metrology-Evolve-In-The-Near-Future.jpg",
  "https://metrology.news/wp-content/uploads/2018/03/AUKUM-CMM-Training-2.jpg",
  "https://www.algosystems.gr/wp-content/uploads/2018/04/shutterstock_1070227943METROLOGY-GENERAL_M.jpg"]

  public currentImg = "https://willrich.com/wp-content/uploads/2018/08/How-Will-Metrology-Evolve-In-The-Near-Future.jpg"

  counter = 0;

  changeImg(key){
    this.counter = key;
    this.currentImg = this.imgSet[key];
  }

  constructor(){
      let root = this;
      setInterval(function(){ 
      if(root.counter > root.imgSet.length-1){root.counter = 0;} 
      root.changeImg(root.counter); root.counter++; }, 4000);
  }

  ngOnInit() {
  }

  ngAfterContentInit(){
  
  }
}
